import React, { Component } from 'react';
import { APP_URL_API } from '../../../../setup/configs'
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import Modal from '../../../../ui/modal/Modal';
import axios from 'axios';

export default class Info extends Component {
	constructor(props) {
        super(props);
        this.state = {
            alertTitle: '',
            alertId: null,
            editorState: EditorState.createEmpty(),
            showMessage: false
        }
    }
    componentDidMount() {
		this.getAlertMessage();
	}
	getAlertMessage = () => {
		const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'alertMessage/latestActiveNotConsented/info';
        	this.serverRequest =
	            axios
	                .get(url, {headers: config})
	                .then(function(result) {
	                	if(result.data!=="") {
	                	this.setState({
	                		showMessage: true,
	                		alertTitle: result.data.data.title,
	                		alertId: result.data.data.id,
	                		editorState: EditorState.createWithContent(convertFromRaw(JSON.parse(result.data.data.message)))
	                	})
	                }
	                }.bind(this))
	}

	createMarkup = (html) => { return {__html: html}; };

	render() {
		if(this.state.showMessage) {
			const rawContentState = convertToRaw(this.state.editorState.getCurrentContent());
			const markup = draftToHtml(
			  rawContentState
			);
			return(
				<div>
					<div className="alertBox alertBox--info">
						<div dangerouslySetInnerHTML={this.createMarkup(markup)} />
					</div>
				</div>
			)
		} else {
			return null
		}
	}
}


// WEBPACK FOOTER //
// ./src/modules/admin/organization/sections/Info.js